import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["iconProps"];
import React from "react";
import styled from "styled-components";
import Link from "../Link";
import PlusFilledIcon from "../Icons/PlusFilledIcon";
var AddIcon = styled(function (props) {
  return /*#__PURE__*/React.createElement(PlusFilledIcon, _extends({
    width: "5px",
    height: "5px"
  }, props));
}).withConfig({
  displayName: "AddSystemButton__AddIcon",
  componentId: "sc-dyns5o-0"
})(["transform:scale(4.5) translateY(-1.1px);"]);
var AddSystemButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var iconProps = _ref.iconProps,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Link, _extends({
    as: "button",
    role: "button",
    color: "ctrl",
    ref: ref
  }, props), /*#__PURE__*/React.createElement(AddIcon, iconProps));
});
export default AddSystemButton;